import React from 'react';
import { useParams } from 'react-router-dom';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Page from '../components/page';
import useGetUnnamedCards from '../hooks/useGetUnnamedCards';
import DataDisplay from '../components/data-display';
import { UnnamedLotInfoContainer, UnnamedLotSectionTitle } from '../components/unnamed-lots-cards.styles';
import { getDateFormatted, sortDateDesc } from '../utils/date';
import { CARD_STATE_TO_HUMAN_TEXT, RealmRoles } from '../constants';
import { IUnnamedLotCard } from '../interfaces/IUnnamedLotsCards';
import withAuthorization from '../components/hocs/withAuthorization';
import { CardBalanceTypeParser } from '../interfaces/card';

const UnnamedLot = () => {
  const { lotNumber } = useParams<{ lotNumber: string }>();

  const { lotSize, cardProductId, type, cards, balanceType, isLoading } = useGetUnnamedCards(lotNumber);

  const columns: ColumnsType<IUnnamedLotCard> = [
    { dataIndex: 'card_id', key: 'card_id', title: 'Card Id' },
    {
      dataIndex: 'card_holder_id',
      key: 'card_holder_id',
      title: 'Card Holder Id',
      render: (_, record) => {
        return record?.card_holder_id != null ? record?.card_holder_id : 'Sin Cardholder'
      }
    },
    {
      dataIndex: 'created_time',
      key: 'created_time',
      title: 'Fecha de Creacion',
      defaultSortOrder: 'descend',
      sorter: (a, b) => sortDateDesc(b.created_time, a.created_time),
      render: (_, record) => {
        return getDateFormatted(record.created_time);
      },
    },
    {
      dataIndex: 'state',
      key: 'state',
      title: 'Estado',
      width: 150,
      render: (_, record) => {
        return CARD_STATE_TO_HUMAN_TEXT[record.state];
      },
    },
    {
      key: 'account',
      dataIndex: ['account'],
      title: 'Cuenta',
      render: (_, record) => {
        return record.account?.map(acct => acct.account_id)
      }
    },
    { dataIndex: 'fourth_line', key: 'fourth_line', title: 'Cuarta Linea' },
    { dataIndex: 'last_four', key: 'last_four', title: 'Ultimos 4 Digitos' },
  ];
  
  return (
    <Page title="Información de Lote">
      <UnnamedLotSectionTitle>Lote</UnnamedLotSectionTitle>
      <UnnamedLotInfoContainer>
        <DataDisplay title="Número de lote" value={lotNumber} />
        <DataDisplay title="Tamaño de lote" value={lotSize} />
        <DataDisplay title="Tipo" value={type} />
        <DataDisplay title="Card Product Id" value={cardProductId} />
        <DataDisplay title="Tipo de balance" value={balanceType ? CardBalanceTypeParser[balanceType] : ''} />
      </UnnamedLotInfoContainer>
      <UnnamedLotSectionTitle>Tarjetas</UnnamedLotSectionTitle>
      <Table
        dataSource={cards || []}
        scroll={{ x: true }}
        columns={columns}
        loading={isLoading}
        pagination={{
          showTotal: () => cards.length > 0 ? `Total: ${cards.length}` : ``,
        }}
      />
    </Page>
  )
}
export default withAuthorization([RealmRoles.CardsUnnamedRead, RealmRoles.CardsUnnamedWrite], UnnamedLot);